import { useState, useEffect } from 'react'
import { copyConfig } from '../../config'
import { Logo } from '../shared/Logo'

export function TopNav() {
  // Check if we're on the demo page to adjust navigation links
  // Use state + effect to avoid SSR issues and ensure updates on navigation
  const [pathname, setPathname] = useState('')

  useEffect(() => {
    // Safely read pathname on client mount
    setPathname(window.location.pathname)
  }, [])

  const isOnDemoPage = pathname === '/open'
  const baseUrl = isOnDemoPage ? '/' : ''

  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-[color:rgba(8,13,24,0.75)] border-b border-border">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-3 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-6 text-sm text-muted">
          <a className="transition hover:text-ink" href={`${baseUrl}#feed`}>Feed</a>
          <a className="transition hover:text-ink" href={`${baseUrl}#signals`}>Signals</a>
          <a className="transition hover:text-ink" href={`${baseUrl}#pricing`}>Pricing</a>
          <a className="transition hover:text-ink" href="/open">{copyConfig.nav_demo_text}</a>
          <a className="transition hover:text-ink" href={`${baseUrl}#faq`}>FAQ</a>
        </nav>
        <div className="flex items-center gap-2">
          <button className="hidden md:inline-flex items-center gap-2 px-3.5 py-2 rounded-xl border border-border-light text-muted hover:text-ink hover:border-brand-glow/40 transition group">
            Founding 100
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-gradient-to-r from-brand-glow/20 to-purple-500/20 border border-brand-glow/30 text-[10px] font-medium text-brand-glow shadow-sm group-hover:shadow-glow/30 transition-shadow">
              join waitlist →
            </span>
          </button>
          <a
            href={`${baseUrl}#pricing`}
            className="px-4 py-2 rounded-xl bg-cta-gradient text-white font-medium shadow-lg shadow-glow/20 transition hover:opacity-90"
          >
            {copyConfig.cta_primary}
          </a>
        </div>
      </div>
    </header>
  )
}
